/* ---------------------------------------------------------
* This file defines all production constants
------------------------------------------------------------ */

export const API_BASE_URL = 'https://subastasback.aeromexicorewards.com/api/v1/auctions/public';
export const API_BASE_URL_PRIVATE = 'https://subastasback.aeromexicorewards.com/api/v1/auctions/private';
export const API_BASE_URL_MEMBER = 'https://member.aeromexicorewards.com/api/v1';
export const API_SOCKET = 'https://subastasnotify.aeromexicorewards.com';
export const MEMBER_URL = 'https://member.aeromexicorewards.com';
export const SUBASTAS_URL = 'https://subastas.aeromexicorewards.com';
